import { formatISO } from 'date-fns';

export const formatISODate = (date: Date) => {
  return formatISO(date, { representation: 'date' });
};
